var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0203 17.9797C15.2884 17.7116 15.2973 17.2798 15.0406 17.0009L10.4372 12L15.0406 6.9991C15.2973 6.72018 15.2884 6.2884 15.0203 6.02033C14.7364 5.73639 14.2732 5.74565 14.0009 6.04071L9.1261 11.3217C8.77251 11.7048 8.77251 12.2952 9.1261 12.6783L14.0009 17.9593C14.2732 18.2544 14.7364 18.2636 15.0203 17.9797Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.445803e0b32954b50452b55d9efac474.svg";
export { ForwardRef as ReactComponent };